{
  "login": "Entrar",
  "logout": "Sair",
  "email": "E-mail",
  "emailAddress": "Endereço de e-mail",
  "emailPlaceholder": "user@example.com",
  "password": "Senha",
  "forgotPassword": "Esqueceu a senha?",
  "rememberMe": "Lembrar-me",
  "signIn": "Entrar",
  "signUp": "Cadastrar",
  "user": "Usuário",
  "tagline": "Plataforma de Gestão de Aluguéis",
  "welcomeBackSubtitle": "Bem-vindo de volta. Por favor insira seus dados.",
  "createAccountSubtitle": "Crie uma conta para começar a gerenciar seus imóveis.",
  "showPassword": "Ver senha",
  "hidePassword": "Ocultar senha",
  "quickAccess": "Acesso Rápido (QA)",
  "quickUsers": {
    "platform_sovereign": "Admin Soberano da Plataforma ({{name}})",
    "platform_admin": "Admin da Plataforma ({{name}})",
    "admin": "Administrador ({{name}})",
    "manager": "Gerente ({{name}})",
    "owner": "Proprietário ({{name}})",
    "tenant": "Inquilino ({{name}})",
    "vendor": "Fornecedor ({{name}})",
    "multi": "Multi-Função Adaptativo ({{name}})"
  },
  "enterEmail": "Digite um endereço de e-mail",
  "loginFailed": "Falha no login",
  "authFailed": "Falha na autenticação",
  "apiError": "{{message}}",
  "guestSessionDetected": "Sessão de convidado ativa",
  "guestSessionDescription": "Você tem um rascunho de convidado não salvo. Ao fazer login, seu progresso será vinculado à sua conta.",
  "guestSessionMigrated": "Seu rascunho de convidado foi salvo na sua conta com sucesso.",
  "passwordMode": "Senha",
  "magicLinkMode": "Link Mágico",
  "sendMagicLink": "Enviar Link Mágico",
  "magicLinkSentTitle": "Verifique seu e-mail",
  "magicLinkSentDescription": "Enviamos um link de login para {{email}}. Clique no link no seu e-mail para entrar.",
  "signInWithPassword": "Entrar com Senha",
  "signInWithMagicLink": "Entrar com Magic Link",
  "or": "ou",
  "resetPasswordTitle": "Redefinir sua senha",
  "resetPasswordDescription": "Digite seu endereço de e-mail e enviaremos um link para redefinir sua senha.",
  "sendResetLink": "Enviar Link de Redefinição",
  "checkYourEmail": "Verifique seu e-mail",
  "resetEmailSentNotice": "Se existir uma conta associada a {{email}}, um link de redefinição de senha foi enviado.",
  "backToSignIn": "Voltar para o login",
  "setNewPasswordTitle": "Criar nova senha",
  "setNewPasswordDescription": "Sua nova senha deve ter pelo menos 8 caracteres e conter letras maiúsculas e números.",
  "newPassword": "Nova Senha",
  "confirmNewPassword": "Confirmar Nova Senha",
  "saveNewPassword": "Redefinir Senha",
  "ruleMinLength": "Pelo menos 8 caracteres",
  "ruleUppercase": "Pelo menos uma letra maiúscula",
  "ruleNumber": "Pelo menos um número",
  "ruleMatch": "As senhas coincidem",
  "passwordResetSuccessTitle": "Senha redefinida com sucesso",
  "redirectingToLogin": "Redirecionando para o login...",
  "invalidResetLinkTitle": "Link inválido ou expirado",
  "invalidResetLinkDescription": "Este link de redefinição de senha é inválido ou expirou.",
  "requestNewResetLink": "Solicitar um novo link",
  "authenticatingLink": "Entrando...",
  "pleaseWait": "Aguarde enquanto verificamos seu link mágico.",
  "magicLinkErrorTitle": "Não foi possível entrar",
  "requestNewLink": "Solicitar um novo link",
  "tabs": {
    "signIn": "Entrar",
    "signUp": "Criar Conta"
  },
  "fields": {
    "fullName": "Nome Completo",
    "fullNamePlaceholder": "Ana Silva",
    "confirmPassword": "Confirmar Senha",
    "phone": "Número de Telefone",
    "phonePlaceholder": "+55 11 91234-5678"
  },
  "buttons": {
    "createAccount": "Criar Conta",
    "creatingAccount": "Criando Conta..."
  },
  "errors": {
    "passwordMismatch": "As senhas não coincidem",
    "accountExists": "Já existe uma conta com este e-mail. Por favor, faça login."
  },
  "accountLinkedNotice": "Conta vinculada com sucesso ao {{provider}}.",
  "enterFullName": "Por favor, digite seu nome completo (mínimo 2 caracteres)",
  "enterValidEmail": "Por favor, digite um endereço de e-mail válido",
  "passwordRequirementsNotMet": "A senha não atende aos requisitos de segurança",
  "organizationName": "Nome da Organização",
  "organizationDefaultPlaceholder": "Por padrão seu nome",
  "organizationDefaultNotice": "Seu espaço de trabalho principal será inicializado automaticamente.",
  "google": "Google",
  "facebook": "Facebook",
  "instagram": "Instagram",
  "whatsapp": "WhatsApp",
  "sms": "SMS",
  "providerUnavailableTooltip": "O login com {{provider}} ainda não está configurado",
  "enterPhone": "Por favor, digite um número de telefone válido",
  "enterValidCode": "Por favor, digite o código de 6 dígitos",
  "otpSendFailed": "Falha ao enviar código de verificação",
  "otpVerifyFailed": "Código de verificação inválido",
  "otpPhoneDescription": "Enviaremos um código de verificação de 6 dígitos para o seu telefone.",
  "otpCodeDescription": "Digite o código de 6 dígitos enviado para {{phone}}.",
  "phoneFormatHint": "Inclua o código do país (ex: +55 para Brasil, +1 para EUA).",
  "sendVerificationCode": "Enviar Código de Verificação",
  "changePhoneNumber": "Alterar telefone",
  "resendCode": "Reenviar código",
  "resendInCountdown": "Reenviar em {{count}}s",
  "cancelToSignIn": "Voltar para o login",
  "useDifferentEmail": "Usar um e-mail diferente",
  "missingMagicToken": "Token do link mágico ausente",
  "magicLinkVerifyFailed": "Não foi possível verificar o link mágico",
  "magicLinkRequestFailed": "Falha ao solicitar o link mágico",
  "completingSocialLogin": "Concluindo seu login...",
  "socialCallbackErrorTitle": "Não foi possível concluir o login social",
  "socialCallbackDenied": "A autorização foi cancelada ou recusada.",
  "unsupportedSocialProvider": "Provedor de autenticação social não suportado.",
  "missingSocialCode": "Código de autorização ausente do provedor social.",
  "invalidOAuthState": "Incompatibilidade de segurança durante o login social. Tente novamente.",
  "socialProviderNotConfigured": "Este provedor de login social não está configurado neste ambiente.",
  "dataDeletionStatusTitle": "Exclusão de dados sociais concluída",
  "dataDeletionStatusDescription": "Sua identidade de login social da Meta (Facebook / Instagram) e os dados vinculados foram removidos do HomyOS.",
  "dataDeletionCodeLabel": "Código de confirmação",
  "social": {
    "continueWithApple": "Continuar com a Apple",
    "signInWithApple": "Entrar com a Apple",
    "continueWithGoogle": "Continuar com o Google",
    "continueWithFacebook": "Continuar com o Facebook",
    "continueWithInstagram": "Continuar com o Instagram",
    "continueWithWhatsApp": "Continuar com o WhatsApp",
    "continueWithSms": "Entrar com SMS",
    "lastUsed": "Último usado",
    "orContinueWith": "Ou continuar com",
    "providerDisabled": "Este método de login não está disponível no momento.",
    "placeholderToast": "O login com {{provider}} estará disponível na próxima versão. No celular, use Apple ou Senha."
  },
  "hero": {
    "badge": "HomyOS 2.0",
    "title": "O sistema operacional para fluxos de propriedades.",
    "subtitle": "Gerencie imóveis, selecione inquilinos, assine contratos e receba pagamentos em uma plataforma única e elegante.",
    "pill1": "99.8% Cobrança Pontual de Aluguel",
    "pill1Sub": "Reconciliação UF automatizada",
    "pill2": "Despacho Automático de Manutenção",
    "pill2Sub": "Aprovação com HITL para prestadores",
    "pill3": "Análise de Aluguéis com IA",
    "copyright": "© 2026 HomyOS",
    "privacy": "Privacidade",
    "terms": "Termos"
  },
  "qa": {
    "title": "Acesso Rápido de Desenvolvimento",
    "badge": "DEV QA",
    "description": "Alterne entre perfis pré-configurados para testar permissões, telas e fluxos.",
    "groups": {
      "platform": "Plataforma e Operações",
      "residents": "Residentes e Proprietários",
      "contractors": "Prestadores e Campo",
      "special": "Multi-Função Adaptativo"
    },
    "instantLogin": "Login em 1 Clique",
    "fillForm": "Preencher Credenciais",
    "close": "Fechar"
  },
  "passkey": {
    "passkey": "Passkey",
    "signInWithPasskey": "Entrar com Chave de Acesso (Passkey)",
    "registerTitle": "Configurar uma Chave de Acesso",
    "registerDescription": "Faça login com segurança usando Touch ID, Face ID ou bloqueio de tela sem digitar senha.",
    "registerButton": "Adicionar Chave de Acesso",
    "prompt": "Use Touch ID, Face ID ou Chave de Segurança",
    "notSupported": "Chaves de acesso não são suportadas neste dispositivo ou navegador.",
    "createdSuccess": "Chave de acesso criada com sucesso!",
    "authSuccess": "Chave de acesso verificada com sucesso!",
    "failed": "Falha na autenticação com chave de acesso. Tente novamente ou use a senha."
  },
  "mfa": {
    "challengeTitle": "Autenticação de Dois Fatores",
    "challengeDescription": "Digite o código de segurança de 6 dígitos gerado pelo seu aplicativo autenticador.",
    "subtitleSms": "Digite o código de verificação de 6 dígitos enviado para o seu telefone.",
    "codeLabel": "Código de Segurança de 6 Dígitos",
    "codePlaceholder": "000000",
    "verifyButton": "Verificar e Entrar",
    "verifying": "Verificando...",
    "useBackupCode": "Usar código de backup",
    "useTotp": "Usar código do aplicativo autenticador",
    "backupCodeLabel": "Código de Backup",
    "backupCodeDescription": "Digite um código de backup de uso único de 8 caracteres.",
    "backupCodePlaceholder": "Digite o código de backup (ex: ABCD-1234)",
    "invalidCode": "Código de segurança inválido. Verifique seu aplicativo e tente novamente.",
    "invalidBackupCode": "Código de backup inválido ou já utilizado."
  },
  "slides": {
    "property": {
      "title": "Gestão Centralizada de Propriedades.",
      "subtitle": "Administre unidades, rastreie finanças e veja análises em uma plataforma unificada e bonita.",
      "pill1Title": "99.8% de Cobrança no Prazo",
      "pill1Sub": "Reconciliação automatizada",
      "pill2Title": "Copiloto Imobiliário com IA",
      "pill2Sub": "Insights de portfólio proativos"
    },
    "maintenance": {
      "title": "Manutenção Automatizada.",
      "subtitle": "Conecte-se perfeitamente com empreiteiros verificados como Patricio para manter suas propriedades em ótimo estado.",
      "pill1Title": "Despacho de Manutenção",
      "pill1Sub": "Aprovação de empreiteiro HITL",
      "pill2Title": "Orçamentos Inteligentes",
      "pill2Sub": "Custos verificados por IA"
    },
    "tenant": {
      "title": "Melhor Experiência para Inquilinos.",
      "subtitle": "Integração simplificada, contratos 100% digitais e pagamentos sem atrito.",
      "pill1Title": "Locação Mais Rápida",
      "pill1Sub": "Contratos 100% Digitais",
      "pill2Title": "Pagamentos Sem Atrito",
      "pill2Sub": "Cobranças automáticas"
    }
  },
  "oauth": {
    "title": "Autorizar {{clientName}}",
    "subtitle": "deseja conectar-se ao seu espaço de trabalho do Homy",
    "clientUnknown": "Aplicação Externa",
    "signInTitle": "Entre para conectar-se ao {{clientName}}",
    "signInSubtitle": "Crie uma conta ou entre para autorizar o acesso ao seu espaço de trabalho do Homy.",
    "permissionsRequested": "Permissões solicitadas",
    "workspaceLabel": "Selecionar Espaço de Trabalho / Organização",
    "workspaceDescription": "Escolha a organização à qual este aplicativo terá acesso.",
    "workspacePlaceholder": "Selecione uma organização...",
    "noWorkspaces": "Nenhuma organização disponível",
    "currentAccount": "Sessão iniciada como",
    "switchAccount": "Entrar com outra conta",
    "starterOrgNotice": "Uma organização inicial será provisionada automaticamente para sua conta.",
    "termsNotice": "Ao clicar em Autorizar, você permite que {{clientName}} acesse suas informações de acordo com seus termos e política de privacidade.",
    "authorizeButton": "Autorizar",
    "cancelButton": "Cancelar",
    "authorizing": "Autorizando...",
    "canceling": "Cancelando...",
    "scopes": {
      "openid": "Verificar sua identidade (OpenID Connect)",
      "profile": "Acessar informações básicas do perfil (nome, avatar)",
      "email": "Ver seu endereço de e-mail",
      "offline_access": "Manter acesso offline com tokens de atualização",
      "homy:all": "Acesso total a todos os dados e operações do espaço de trabalho",
      "homy:mcp": "Executar ferramentas de agentes de IA e ações do Model Context Protocol (MCP)",
      "mcp:read": "Acesso de leitura a propriedades, tarefas, inquilinos e manutenção via MCP",
      "mcp:write": "Criar e modificar tarefas, ordens de manutenção e propriedades via MCP",
      "read": "Acesso de leitura aos dados da sua conta",
      "write": "Acesso de escrita para realizar ações em seu nome"
    },
    "errors": {
      "missingParams": "Solicitação de autorização inválida: parâmetros obrigatórios ausentes (client_id, redirect_uri ou code_challenge).",
      "clientFetchFailed": "Não foi possível verificar os detalhes do cliente. Você ainda pode prosseguir se confiar neste aplicativo.",
      "authorizeFailed": "Falha ao concluir a autorização. Por favor, tente novamente.",
      "accessDenied": "A solicitação de autorização foi cancelada."
    }
  }
}
